import React from 'react';
import PropTypes from 'prop-types';
import { NavDropdown, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
//slices
import { companySelector } from 'slices/company';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import CustomDropdown from 'components/navbar/CustomDropdown';

const MenuItems = ({ blogCategories, setShowOffCanvas, isDesktop }) => {
  const { t, i18n } = useTranslation(['header']);
  const { menus } = useSelector(companySelector);
  const { assignedLibrary } = useAssignedLibrary();

  return (
    Array.isArray(menus) && menus.map((menu) => {
      const { text, url, id, keyword } = menu
      const translatedText = menu[`text_${i18n.language}`] || text;
      switch (keyword) {
        case '#books':
          return (
            <CustomDropdown
              setShowOffCanvas={setShowOffCanvas}
              isDesktop={isDesktop}
              menu={menu}
              key={id}
            />
          )
        case '#blog':
          return (
            <NavDropdown
              title={t(text).toLocaleUpperCase()}
              className={setShowOffCanvas ? 'navbar-item-border' : 'dropdown-lipareso'}
              key={id}
            >
              {blogCategories?.length > 0 &&
                blogCategories?.map((cat) => {
                  return (
                    <NavDropdown.Item
                      as={Link}
                      to={{ pathname: `/${assignedLibrary}/blog/${cat.id}/${cat.slug}/` }}
                      key={cat.id}
                      onClick={() => setShowOffCanvas && setShowOffCanvas(false)}
                      eventKey={`/blog/${cat.id}/${cat.slug}/`}
                    >
                      {cat.name}
                    </NavDropdown.Item>
                  );
                })}
            </NavDropdown>
          );
        case '#gallery':
          const urlGallery = `/${assignedLibrary}/gallery`;
          return (
            <Nav.Link
              as={Link}
              to={urlGallery}
              onClick={() => setShowOffCanvas && setShowOffCanvas(false)}
              className={setShowOffCanvas && 'navbar-item-border'}
              eventKey={urlGallery}
              key={id}
            >
              {t(translatedText).toLocaleUpperCase()}
            </Nav.Link>
          )
        case '#infantil':
          const urlChildren = `/${assignedLibrary}/para-infantil`;
          return (
            <Nav.Link
              as={Link}
              to={urlChildren}
              onClick={() => setShowOffCanvas && setShowOffCanvas(false)}
              className={setShowOffCanvas && 'navbar-item-border'}
              eventKey={urlChildren}
              key={id}
            >
              {t(translatedText).toLocaleUpperCase()}
            </Nav.Link>
          )
        default:
          const isObject = typeof url === 'object';
          let finalUrl = isObject ? `${url.pathname}${url.search}` : url;
          if (!finalUrl.startsWith(`/libelista/`)) {
            finalUrl = `/${assignedLibrary}${finalUrl}`;
          }
          return (
            <Nav.Link
              as={Link}
              to={finalUrl}
              onClick={() => setShowOffCanvas && setShowOffCanvas(false)}
              className={setShowOffCanvas && 'navbar-item-border'}
              eventKey={finalUrl}
              key={id}
              state={url.state || {}}
            >
              {t(translatedText).toLocaleUpperCase()}
            </Nav.Link>
          )
      }
    })
  );
};

MenuItems.propTypes = {
  isDesktop: PropTypes.bool,
  blogCategories: PropTypes.any,
  setShowOffCanvas: PropTypes.func
};

export default MenuItems;
